import { IParentEmail } from "../../../model/respone/category/IParentEmail";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eEmailPhuHuynhActionTypeDefine = {
  LOAD_START: 0 as number,
  LOAD_SUCCESS: [] as IParentEmail[],
  LOAD_ERROR: "",
};

export const eEmailPhuHuynhActionTypeIds = generateActionTypeIds(
  eEmailPhuHuynhActionTypeDefine,
  "EMAIL_PHU_HUYNH"
);

export type IEmailPhuHuynhActions = IGenericActionType<
  typeof eEmailPhuHuynhActionTypeDefine,
  "EMAIL_PHU_HUYNH"
>;
